<div class="modal">
  <app-loading *ngIf="loading"></app-loading>
  <app-modal-header title="You must log in again to proceed" icon="lock_outline"
    closeLabel="Close password confirmation" [closeDisabled]="loading" (closed)="cancel()"></app-modal-header>
  <div class="modal-body">
    <p class="mb-2">Hi {{ userName }}, you're trying to view/modify sensitive data, so you need to provide your password again to proceed.</p>
    <ng-container [formGroup]="form">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" placeholder="Enter your password" />
        <mat-error *ngIf="form.get('password')?.hasError('required')">The password is required</mat-error>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="hr mb-1 mt-2"></div>
  <div class="modal-footer text-end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="executeTargetAction()" [disabled]="form.invalid">{{ confirmButtonText }}</button>
  </div>
</div>
